<template>
  <div class="component-container" style="display: block">
    <label v-if="showLabel()"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <div :style="inputStyle" class="mianze">
      <div v-html="value"></div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'jtText',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    value: {
      type: String,
      default: '',
    },
    compWidth: {
      type: String,
      default: '100%',
    },
    placeholder: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    minLength: {
      type: Number,
      default: 1,
    },
    maxLength: {
      type: Number,
      default: 100,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      val: this.value,
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      inputStyle: {
        width: window.innerWidth > 768 ? '700px' : '100%',
      },
      hasFiredEnterEventHandler: false,
    }
  },
  methods: {
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },
    focus() {
      this.$refs.component.focus()
    },
    handleEnter() {
      try {
        this.hasFiredEnterEventHandler = true
        this.$emit('enter')
        this._save()
      } catch (err) {
        this.$emit('datas', err, null)
      }
    },
    handleBlur() {
      try {
        if (this.hasFiredEnterEventHandler) {
          this.hasFiredEnterEventHandler = false
          return
        }
        this._save()
      } catch (err) {
        this.$emit('datas', err, null)
      }
    },

    _save() {
      const value = _.trim(this.val)
      if (!_.isEmpty(value)) {
        this._validate(value)
        this.val = value
      }

      this.$emit('datas', null, value)
    },
  },
}
</script>

<style lang="stylus">
.component-container {
  // display: block;
  // flex-direction: row;
  // align-items: baseline;
}

.component-container .is-disabled .el-input__inner {
  color: #666666;
}

.mianze {
  // max-height: 220px;
  border: 1px solid #DCDFE6;
  overflow-y: auto;
  margin-top: 8px;

  div {
    padding: 5px;
  }
}
</style>
